import React, { useEffect, useState } from 'react';
import { eFormsignControl } from '../../lib/eFormSignHelper';
import { Modal } from 'antd';
import { modalErrorStyle } from '../../lib/util/codeUtil';

const EFormsignModal = ({
  close,
  resulteFormsignInfo,

  frIdx,
  frName,
  businessNumber,
  ownerName,
  branchIdx,
  branchName,
}) => {
  const [documentId, setDocumentId] = useState(0);

  useEffect(() => {
    eFormsignControl.openAgreeTermsDoc(
      'eformsign_iframe',
      frIdx,
      frName,
      businessNumber,
      ownerName,
      branchIdx,
      branchName,
      fnSuccesss_eFormsignControl,
      fnError_eFormsignControl
    );
  }, [frIdx]);

  const fnSuccesss_eFormsignControl = (response) => {
    if (response.code == '-1') {
      //문서 작성 성공
      setDocumentId(response.document_id);
      resulteFormsignInfo &&
        resulteFormsignInfo(
          frIdx,
          branchIdx,
          response.document_id,
          response.code
        );

      console.log(
        `branchIdx: ${branchIdx}, fridx: ${frIdx}, documentId: ${response.document_id}`
      );
    } else {
      console.log(response.code);

      resulteFormsignInfo(
        frIdx,
        branchIdx,
        response.document_id,
        response.code
      );
    }

    close();
  };

  const fnError_eFormsignControl = (response) => {
    //문서 작성 실패
    console.log(response.code);
    
    resulteFormsignInfo(frIdx, branchIdx, response.document_id, response.code);
  };

  return (
    <React.Fragment>
      <div className="Modal-detail-overlay eformsign" onClick={() => {}}>
        <div className="Modal-detail eformsign" style={{ textAlign: 'left' }}>
          <iframe
            id="eformsign_iframe"
            frameborder="0"
            width="1024"
            height="700">
          </iframe>
        </div>
      </div>
    </React.Fragment>
  );
};
export default EFormsignModal;
